import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';

var Container = function Container(_ref) {
  var className = _ref.className,
      fluid = _ref.fluid,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      props = _objectWithoutProperties(_ref, ["className", "fluid", "small", "medium", "large"]);

  var children = props.children;
  var classes = classNames('Container', className, {
    container: !fluid,
    'container--small': small,
    'container--medium': medium,
    'container--large': large,
    'container--fluid': fluid
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, props), children);
};

Container.defaultProps = {
  small: false,
  large: false,
  fluid: false
};
Container.propTypes = {
  small: PropTypes.bool,
  large: PropTypes.bool,
  fluid: PropTypes.bool
};
export default Container;